export const handleTabChange =
    (setSelectedTab: (selectedTab: string) => void) =>
    (value: string): void => {
        setSelectedTab(value)
    }
